import {Vector2, Vector2Like} from "@cm/math"
import {CrosshairToolboxItem} from "@app/textures/texture-editor/operator-stack/operators/shared/toolbox/crosshair-toolbox-item"
import {ToolMouseEvent} from "@common/helpers/canvas/canvas-base-toolbox-legacy/canvas-base-toolbox-item"
import {TilingCanvasBaseToolboxItem} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/tiling-canvas-toolbox-item"
import {CanvasToolboxItem} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item"

export class SelectCloneSourceToolboxItem extends CrosshairToolboxItem {
    constructor(parent: TilingCanvasBaseToolboxItem) {
        super(parent)
        this.cursor = "crosshair"
        this.cloneSourcePosition = new Vector2(0, 0)
    }

    override hitTest(point: Vector2Like): CanvasToolboxItem | null {
        if (this.selected && this.callback.isPointInImage(point)) {
            return this
        }
        return null
    }

    override onMouseDown(event: ToolMouseEvent): boolean {
        super.onMouseDown(event)
        this.cloneSourcePosition = event.point.floor()
        return false
    }

    override onMouseDrag(event: ToolMouseEvent): boolean {
        super.onMouseDrag(event)
        this.cloneSourcePosition = event.point.floor()
        return false
    }

    set cloneSourcePosition(value: Vector2Like) {
        this._cloneSourcePosition.setFromVector2Like(value)
        this.crosshairPosition = this._cloneSourcePosition.add(new paper.Point(0.5, 0.5))
    }

    get cloneSourcePosition(): Vector2 {
        return this._cloneSourcePosition
    }

    private _cloneSourcePosition = new Vector2(0, 0)
}
